import React from 'react';
import {ProductProvider} from 'contexts/ProductContext';
import {
    Products,
    ProductsProps,
} from 'components/customer/Product/ProductsWithProvider';

import './product.scss';

export const ProductWrapper = ({showTitle = true}: ProductsProps) => {
    return (
        <ProductProvider miniBrowser={!showTitle}>
            <Products showTitle={showTitle} isMiniBrowser={!showTitle} />
        </ProductProvider>
    );
};

export default ProductWrapper;
